import { Injectable } from '@angular/core';

import { TaskMapper } from '../contracts/task-mapper.contract';
import { OrphanedOfferingItem, TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

@Injectable()
export class OrphanedOfferingTaskMapper implements TaskMapper<TaskType.OrphanedOffering> {
  readonly type = TaskType.OrphanedOffering;

  map(r: TaskResponse): TaskDataMap[TaskType.OrphanedOffering] {
    const rawOfferings: OrphanedOfferingItem[] = r.data?.['offerings'] ?? [];
    return {
      partnerId: r.data?.['partnerId'] ?? '',
      partnerName: r.data?.['partnerName'] ?? '',
      integration: r.data?.['integration'] ?? '',
      offerings: rawOfferings.map(o => ({
        id: o?.id ?? '',
        name: o?.name ?? '',
        code: o?.code ?? '',
        externalCode: o?.externalCode ?? '',
      })),
    };
  }
}
